import { FC } from "react";
import st from "./ProductTextDescription.module.scss";

type ProductTextDescriptionProps = {
  description?: {
    __typename?: string;
    header?: string | null | undefined;
    text?: string | null | undefined;
  }[];
};

export const ProductTextDescription: FC<ProductTextDescriptionProps> = ({
  description,
}) => {
  return (
    <div className={st.descriptionContainer}>
      {description?.map((item) => (
        <div className={st.descriptionItem} key={item.header}>
          <div className={st.header}>{item.header}</div>
          <div className={st.text}>{item.text}</div>
        </div>
      ))}
    </div>
  );
};
